<template>
  <div class="vehicle" v-if="titles">
    <div class="vehicle_select">
      <button 
        class="vehicle_select-prev vehicle_select-btn"
        :disabled="isSelectedMin"
        @click="changeGraphic('prev')"
      >
        <span class="material-icons">
          arrow_forward_ios
        </span>
      </button>

      <select
        @change="changeSelectTitle($event)"
        v-model="selectedTitle"
      >
        <option
          v-for="item in titles"
          :key="item.key"
          :value="item.key"
        > 
          {{ item.title }}
        </option>
      </select>
      <button 
        class="vehicle_select-next vehicle_select-btn"
        @click="changeGraphic('next')"
        :disabled="isSelectedMax"
      >
        <span class="material-icons">
          arrow_forward_ios
        </span>
      </button>
    </div>
    
    <div
      v-for="(item, index) in titles"
      :key="index"
    >
      <CastomGraphic
          v-if="item.key == selectedTitle"
          :received-data="receivedData[item.key]"
          :graph-type="graphType"
          :index-axis="indexAxis"
          :id="('vehicle-' + item.key + id)"
          :is-title="false"
          :aspect-ratio="2"
          :data-labels="false"
          :maintain-aspect-ratio="true"
      />
    </div>  
  </div>
</template>
<script>

import graphApi from '@/api/graphApi'
import 'vue-material-design-icons/styles.css';

export default {
  name: 'SelectGraphic',
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  props: {
    receivedData: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    graphType: {
      type: String,
      default: 'line'
    },
    indexAxis: {
      type: String,
      default: 'x'
    }
  },

  data () {
    return {
      selectedTitle: null,
      selectedTitleIndex: 0,
      titles: null
    }
  },
  created () {
    this.getTitles()
  },
  computed: {
    isSelectedMax () {
      return this.selectedTitleIndex >= this.receivedData.length
    },
    isSelectedMin () {
      return this.selectedTitleIndex < 1
    },

    itemSelectReceivedData () {
      return (key) => {
        let receivedData = receivedData[key].data.sort()
        return receivedData
      }
    }
  },
  methods: {
    changeSelectTitle (event) {
      this.selectedTitle = event.target.value
      this.$forceUpdate()
    },

    changeGraphic (type) {
      this.receivedData.forEach((item, index) => {
        if (index == this.selectedTitle) {
          if (type == 'prev') {
            this.selectedTitleIndex--
          } else {
            this.selectedTitleIndex++
          }
        }
      })

      if (!this.isSelectedMax) {
        this.selectedTitle = this.titles[this.selectedTitleIndex].key
      }
    },

    getTitles () {
        this.titles = []
        this.receivedData.forEach((item, index) => {
          this.titles.push({
            key: index,
            title: item.sub_title
          })
        })
        
        this.selectedTitle = this.titles[0].key
        this.selectedTitleIndex = 0
    }
  }
}
</script>
<style lang="scss" scoped>
  .vehicle {
    background-color: #fff;
    &_select {
      display: flex;
      border-radius: 5px;

      &-btn {
        background-color:#e5e5e5;
        display: flex;
        align-items: center;
        padding: 10px 10px;
        border-radius: 5px;
        cursor: pointer;

        &:disabled {
          background-color: #cdcdcd;
          cursor: default;
        }

        span {
          text-align: center;
          display: flex;
          align-content: center;
        }
      }

      &-prev {
        span {
          transform: rotate(180deg);
        }
      }
      
      select {
        background-color:#e5e5e5;
        padding: 10px 20px;
        cursor: pointer;
        border-radius: 5px;
        margin-right: 10px;
        margin-left: 10px;
        width: 100%;
      }
    }
  }
</style>